module.exports = "<div class=\"logo\">\n  <a><img src=\"./assets/img/ace-logo.png\" alt=\"asna logo\"></a>\n</div>\n\n<div class=\"enterBtn\">\n  <div class=\"btnRadius\">\n    <a class=\"button gradient cyan\" routerLink=\"auth\" (click)=\"redirect()\">Enter</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/asna/front-end/public_html/src/app/components/info/info.component.html
// module id = ../../../../../src/app/components/info/info.component.html
// module chunks = main